import LazyLoad from "vanilla-lazyload";
import Gallery from "../blocks/gallery";
import PartnersSlider from "../blocks/partners-slider";

const Common = {
  lazyLoadInstance: null,

  init() {
    this.lazyLoadInstance = new LazyLoad();

    Common.blocks();
    Common.events();
    Common.tabs();
    Common.closeNotice();
    Common.divisionNav();
    Common.sideNav();
    Common.copyProps();
    Common.anchorTags();
  },

  blocks() {
    document.querySelectorAll(".gallery").forEach(function (gallery) {
      new Gallery(gallery);
    });

    document.querySelectorAll(".partners").forEach(function (slider) {
      new PartnersSlider(slider);
    });
  },

  events() {
    // SEO
    $(".seo-read-more").on("click", function (e) {
      $(this).parent().toggleClass("show");
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Video.
    $(".js-play-video").on("click", function () {
      const wrapper = $(this).closest(".video");
      wrapper.addClass("playing");

      if (wrapper.find("video").length) {
        wrapper.find("video")[0].play();
      }

      if (wrapper.find("iframe").length) {
        wrapper.find("iframe").attr("src", wrapper.find("iframe").data("src"));
        wrapper.find("iframe").click();
      }
    });

    // Accordion
    $(".accordion").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    // SEO
    $(".seo__more-btn").on("click", function () {
      let content = document.getElementsByClassName("seo__content-2")[0];
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      let text = $(this).children()[0].innerText;

      if (text == "LASĪT VAIRĀK") {
        $(this).children("span").text("Lasīt mazāk");
      } else {
        $(this).children("span").text("Lasīt vairāk");
      }

      $(this).toggleClass("active");
    });
  },

  /**
   * Tabs
   */
  tabs() {
    // Show first
    $("[data-tabs] [data-container]").not(":first-child").hide();
    $("[data-tabs] [data-target]").first().addClass("active");

    $("[data-target]").on("click", function () {
      const btnEl = $(this);
      const tabEl = btnEl.closest("[data-tabs]");

      const targetTab = btnEl.data("target");

      btnEl.parent().siblings().children().removeClass("active");
      btnEl.addClass("active");

      tabEl.find("[data-container]").hide();
      tabEl.find(`[data-container="${targetTab}"]`).show();
    });

    $('[data-target="1"]').addClass("active");
  },

  // Close blue notice
  closeNotice() {
    $(".notice__close").on("click", function (e) {
      e.preventDefault();
      $(this).closest(".notice").toggleClass("hidden");
    });
  },

  divisionNav() {
    const largeItemsBlock = $(".division-nav__large-items");

    if (largeItemsBlock.children().length > 1) {
      largeItemsBlock.addClass("has-many");
    }

    if (window.innerWidth < 1200) {
      $(".nav-item__title-wrap").on("click", function () {
        $(this).toggleClass("active").parent().next().slideToggle();
      });
    }
  },

  sideNav() {
    $(".side-nav__open-btn").on("click", function (e) {
      e.preventDefault();
      $(".side-nav").toggleClass("active");
      $("html").toggleClass("no-scroll");
    });

    $(".side-nav__item a").on("click", function (e) {
      $(".side-nav__item").removeClass("active");

      $(this).parents(".side-nav__item").addClass("active");
      $(this).parent().parent().addClass("open");
    });

    $(".side-nav__toggle").on("click", function () {
      // $(this).parent().next().slideToggle();
      $(this).parent().parent().toggleClass("open");
    });
  },

  // Copy properties and show alert

  copyProps() {
    //Copy one property to clipboard
    $(".properties-list__item").on("click", function () {
      var oneProperty = $(this)
        .find(".properties-list__item-value span")
        .text()
        .trim();
      copyText(oneProperty);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };
      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    //Copy all properties to clipboard
    $(".properties-list__copy-all").on("click", function () {
      var allProperties = "";
      $(".properties-list")
        .find(".properties-list__item-name, .properties-list__item-value span")
        .each(function () {
          allProperties += $(this).text().trim() + "\n";
        });

      copyText(allProperties);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };

      const toggleText = () => {
        $(this).find("span").toggleClass("hidden");
      };

      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    //Copy property URL to clipboard
    $(".properties-list__copy-link").on("click", function () {
      let url = $(this).data("url");
      copyText(url);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };
      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    /**
     * Copy text to clipboard
     */
    function copyText(text) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
  },

  anchorTags() {
    function handleAnchorTags() {
      // Function to handle smooth scrolling
      function smoothScrollToHash(hash) {
        const viewportWidth = window.innerWidth;

        const targetElement = document.getElementById(hash);
        if (targetElement) {
          const headerOffset = (viewportWidth > 1200) ? 200 : 100;
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }

      // Handle anchor clicks
      document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          // Get the current URL without the hash part
          const currentUrl = window.location.href.split('#')[0];

          // Get the href of the anchor and split by the hash
          const anchorHref = this.href.split('#')[0];

          // Check if the URL before the hash matches the current URL
          if (currentUrl === anchorHref) {
            e.preventDefault();

            const targetId = this.href.split('#')[1];
            smoothScrollToHash(targetId);
          }
        });
      });

      // Handle page load with hash in URL
      if (window.location.hash) {
        const initialHash = window.location.hash.substring(1); // Remove the leading #

        // Delay the scroll to ensure the content is fully loaded
        window.addEventListener('load', function () {
          // Using requestAnimationFrame to ensure the scroll happens after layout rendering
          requestAnimationFrame(() => {
            smoothScrollToHash(initialHash);
          });
        });
      }
    }
    handleAnchorTags();
  }

};

export default Common;
